module.exports = __webpack_public_path__ + "img/logo.c5fbd548.png";